import React from "react";
import ReactDOMServer from "react-dom/server";

function AccountStatementPDFTableSectionStatic(data) {
  const detailsRows = data?.records || [];

  const staticContent = (
    <div className="w-full">
      <table className="w-full border-collapse">
        <thead className="border-y-2 border-black">
          <tr>
            <td className="px-2 py-3 text-sm font-semibold text-center border-black border-t-2 border-b-2 border-l-2 border-r-2">
              Date
            </td>
            <td className="px-2 py-3 text-sm font-semibold text-center border-black border-t-2 border-b-2 border-r-2">
              Action
            </td>
            <td className="px-2 py-3 text-sm font-semibold border-black border-t-2 border-b-2 border-r-2">
              Description
            </td>
            <td className="px-2 py-3 text-sm font-semibold text-center bg-red-200 border-black border-t-2 border-b-2 border-r-2">
              Debits (-)
            </td>
            <td className="px-2 py-3 text-sm font-semibold text-center bg-green-200 border-black border-t-2 border-b-2 border-r-2">
              Credits (+)
            </td>
            <td className="px-2 py-3 text-sm font-semibold text-center border-black border-t-2 border-b-2 border-r-2">
              Commission
            </td>
            <td className="px-2 py-3 text-sm font-semibold border-black border-t-2 border-b-2 border-r-2">
              Markup
            </td>
            <td className="px-2 py-3 text-sm font-semibold text-center border-black border-t-2 border-b-2 border-r-2">
              Balance
            </td>
          </tr>
        </thead>
        <tbody>
          {detailsRows.map((record, i) => {
            const isLast = i === detailsRows.length - 1;
            const tdBottomBorder = isLast ? "border-b-2" : "";

            return (
              <tr key={i}>
                <td
                  className={`px-2 py-3 text-sm text-center border-black border-l-2 border-r-2 ${tdBottomBorder}`}
                >
                  {record?.date}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.action}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-left border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.description}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center bg-red-100 text-red-800 border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.debits}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center bg-green-100 text-green-800 border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.credits}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.commission}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.markup}
                </td>
                <td
                  className={`px-2 py-3 text-sm text-center border-black border-r-2 ${tdBottomBorder}`}
                >
                  {record?.balance}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default AccountStatementPDFTableSectionStatic;
